package com.anjuros.website.templates.template9.modules

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalUiMode
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.templates.selection.util.Constants.placeholderPrimaryColor
import com.anjuros.website.templates.selection.util.Constants.placeholderPrimaryColorOpacity
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.argb
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.rgb

enum class Template9Theme(
    val hex: String,
    val rgb: CSSColorValue
) {
    Primary(hex = "#1F5C3A", rgb = rgb(r = 31, g = 92, b = 58)),
    OpacityPrimary(hex = "#1F5C3A1A", rgb = argb(a = 0.1f, r = 31, g = 92, b = 58)),
    Accent(hex = "#F6C344", rgb = rgb(r = 246, g = 195, b = 68)),
    Secondary(hex = "#1B2142", rgb = rgb(r = 27, g = 33, b = 66)),
    Background(hex = "#FCF8F2", rgb = rgb(r = 252, g = 248, b = 242)),
    Cream(hex = "#F7F0E5", rgb = rgb(r = 247, g = 240, b = 229)),
    Card(hex = "#FBF6EE", rgb = rgb(r = 251, g = 246, b = 238)),
    Text(hex = "#4F5468", rgb = rgb(r = 79, g = 84, b = 104)),
    Border(hex = "#EFE6D8", rgb = rgb(r = 239, g = 230, b = 216)),
}

@Composable
fun Template9Theme.getColor(): CSSColorValue {
    return if (LocalUiMode.current == UiMode.NORMAL)
        this.rgb
    else
        placeholderPrimaryColor.rgb
}

@Composable
fun Template9Theme.getColorOpacity(): CSSColorValue {
    return if (LocalUiMode.current == UiMode.NORMAL)
        this.rgb
    else
        placeholderPrimaryColorOpacity.rgb
}

@Composable
fun Template9Theme.getColorHex(): String {
    return if (LocalUiMode.current == UiMode.NORMAL)
        this.hex
    else
        placeholderPrimaryColor.hex
}
